import React, { useState } from "react";
import PropTypes from "prop-types";
import { Input, Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../../assets/images/closeIconModal.svg";
import ErrorModal from "Components/Common/ErrorModal";

const ConfirmOrderModal = ({
  show,
  onCloseClick,
  onConfirm,
  orderDetail,
}: any) => {
  const [selectedTime, setSelectedTime] = useState<number | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const handleTimeSelect = (time: any) => {
    setSelectedTime(time);
  };
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showModal, setShowModal] = useState({
        isVisible: false,
        color: false,
      });


  const handleSubmit = () => {
    if (selectedTime) {
      onConfirm(selectedTime);
      setSubmitted(true);
    }
    else {
      setSubmitted(false);
        setShowModal({ isVisible: true, color: false });
          setErrorMessage(`Please Select time first`);
          setTimeout(() => {
            setShowModal({ isVisible: false, color: false });
          }, 1000);
    }
  };

  const formatStatus = (status:any) => {
    if (!status) return "Unknown Status";
  
    return status
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str:any) => str.toUpperCase()); 
  };
  
  const formattedStatus = formatStatus(orderDetail?.status);

  return (
    <>
    <ErrorModal
                    show={showModal.isVisible}
                    message={errorMessage}
                    color={showModal.color}
                    onCloseClick={() => setShowModal({ isVisible: false, color: false })}
                  />
    <Modal isOpen={show} centered={true} className="reasonModl">
      <ModalBody className="modal_Body">
          <img
            data-testing-id="closeIcon"
            onClick={() => onCloseClick(false)}
            className='closeIconModal'
            src={CLoseImg}
            alt=""
          />
        <div className="mainDv">
          <div className="flexDv">
            <h1>Confirm Order Preparation Time</h1>
            <a>
              <div className="dot"></div>
              {formattedStatus}
            </a>
          </div>
          <h6>Order Details (#{orderDetail?.buypassId})</h6>
          <p>Select how much time you need to prepare this order.</p>
          <div className="radioDv">
            {[
              { name: "5 Min", value: 5 },
              { name: "15 Min", value: 15 },
              { name: "30 Min", value: 30 },
              { name: "45 Min", value: 45 },
            ].map((time , index) => (
              <div key={time.value} className="contDv">
                <Input
                  type="radio"
                  className="form-check-input rounded-circle mt-0 me-2"
                  data-testing-id={'checkBoxTime' + index}
                  value={time.value}
                  checked={selectedTime === time.value}
                  onChange={() => handleTimeSelect(time.value)}
                />
                <h6>{time.name}</h6>
              </div>
            ))}
          </div>
          <div className="btnDv">
          <button onClick={handleSubmit} data-testing-id='submintBtn_timerModal'  >
              {submitted ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
    </>
  );
};

ConfirmOrderModal.propTypes = {
  onCloseClick: PropTypes.func,
  onConfirm: PropTypes.func,
  show: PropTypes.bool,
  orderDetail: PropTypes.any,
};

export default ConfirmOrderModal;
